<mat-card>
  <div class="button-row">Signed Out.</div>
  <div class="button-row">
    <button mat-raised-button color="primary" (click)="authService.login()">Login</button>
  </div>
</mat-card>
